import { useEffect, useRef } from 'react';
import { getSocket } from '../utils/socket/socket.instance';
import { SOCKET_EVENTS } from '../utils/constants';

export const useInfluencerRoom = influencerId => {
  const prevChatIdRef = useRef(null);

  useEffect(() => {
    const socket = getSocket();
    if (!socket || !influencerId) return;

    const joinRoom = () => {
      socket.emit(SOCKET_EVENTS.SWITCH_INFLUENCER_ROOM, { influencerId });
    };

    if (socket.connected) {
      joinRoom();
    }

    socket.on(SOCKET_EVENTS.CONNECTED, joinRoom);

    prevChatIdRef.current = influencerId;

    return () => {
      socket.off(SOCKET_EVENTS.CONNECTED, joinRoom);
    };
  }, [influencerId]);
};
